<template>
  <div class="descriptions-table">
    <div class="title">{{ title }}</div>
    <div class="table-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'descriptions',
  props: {
    title: { type: String }
  }
};
</script>

<style lang="scss" scoped>
.descriptions-table {
  .title {
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;
    font-weight: 600;
  }

  .table-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
}
</style>
